import React from "react";

function Whatsapp() {
  return (
    <div>
      <svg
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.44531 30.6743L5.35356 23.7078C4.17631 21.6692 3.55723 19.3558 3.55794 16.9864C3.56148 9.57372 9.59365 3.54297 17.0071 3.54297C20.6047 3.54439 23.9806 4.94476 26.52 7.48555C29.0586 10.0271 30.4569 13.4044 30.4555 16.9971C30.4526 24.4098 24.4191 30.4412 17.0071 30.4412H17.0014C14.751 30.4405 12.5389 29.876 10.5747 28.8043L3.44531 30.6743Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.44761 31.0271C3.35411 31.0271 3.26344 30.9903 3.19615 30.9223C3.10761 30.8323 3.0729 30.7013 3.10619 30.5802L4.97548 23.7547C3.81665 21.6962 3.20536 19.3587 3.20677 16.9858C3.20961 9.37692 9.40115 3.1875 17.0094 3.1875C20.6998 3.18892 24.1671 4.62613 26.773 7.23421C29.379 9.843 30.8134 13.3096 30.8119 16.9957C30.8091 24.604 24.6169 30.7941 17.0094 30.7941C14.7505 30.7934 12.5157 30.2359 10.5324 29.1812L3.53757 31.0151C3.50782 31.0236 3.47807 31.0271 3.44761 31.0271Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0126 3.54036C20.6102 3.54178 23.9861 4.94216 26.5255 7.48295C29.0641 10.0244 30.4624 13.4018 30.461 16.9944C30.4581 24.4072 24.4246 30.4386 17.0126 30.4386H17.0069C14.7565 30.4379 12.5444 29.8734 10.5802 28.8017L3.45081 30.6717L5.35906 23.7052C4.18181 21.6666 3.56273 19.3532 3.56344 16.9838C3.56698 9.57112 9.59915 3.54036 17.0126 3.54036ZM17.0126 2.83203C9.20956 2.83203 2.85865 9.18011 2.8551 16.9838C2.8544 19.3688 3.45648 21.719 4.59831 23.7994L2.76727 30.4854C2.70069 30.7297 2.76869 30.9904 2.94719 31.1703C3.08177 31.3063 3.26381 31.3807 3.45081 31.3807C3.51102 31.3807 3.57123 31.3729 3.63073 31.3573L10.4924 29.5582C12.4955 30.598 14.7409 31.1469 17.0069 31.1477C24.8156 31.1477 31.1665 24.7989 31.17 16.9952C31.1714 13.2134 29.7002 9.65753 27.0277 6.98286C24.3537 4.30749 20.7972 2.83345 17.0126 2.83203Z"
          fill="#CFD8DC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.9135 9.08925C22.8026 6.977 19.9969 5.81321 17.0106 5.8125C10.8452 5.8125 5.83096 10.8247 5.82813 16.9857C5.82742 19.0973 6.41817 21.1529 7.53733 22.9329L7.80367 23.3558L6.67388 27.479L10.9048 26.3697L11.3135 26.612C13.029 27.6306 14.9968 28.1689 17.0028 28.1696H17.007C23.1681 28.1696 28.1824 23.1567 28.1845 16.995C28.1852 14.0093 27.0243 11.2015 24.9135 9.08925Z"
          fill="#40C351"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6448 11.366C13.3934 10.8064 13.1285 10.7951 12.8883 10.7852C12.6921 10.7767 12.4683 10.7774 12.2445 10.7774C12.0206 10.7774 11.6565 10.8616 11.3484 11.1981C11.0403 11.5346 10.1719 12.347 10.1719 14.0003C10.1719 15.6535 11.376 17.2515 11.5439 17.4754C11.7118 17.6992 13.8687 21.2005 17.2843 22.5477C20.1225 23.6669 20.7005 23.4445 21.3168 23.3885C21.933 23.3326 23.3051 22.5761 23.5849 21.7912C23.8647 21.0064 23.8647 20.3342 23.7811 20.1939C23.6968 20.0537 23.473 19.9701 23.1372 19.8015C22.8015 19.6329 21.1489 18.8205 20.8408 18.7086C20.5327 18.5966 20.3088 18.5407 20.0843 18.8772C19.8605 19.2129 19.2166 19.9701 19.0204 20.1939C18.8242 20.4185 18.628 20.4468 18.2922 20.2782C17.9565 20.1097 16.8741 19.7555 15.5899 18.6108C14.5912 17.7204 13.9168 16.6204 13.7206 16.2839C13.5244 15.9482 13.6994 15.7662 13.868 15.5983C14.0188 15.4474 14.2037 15.2059 14.3723 15.0096C14.5402 14.8134 14.5961 14.6732 14.708 14.4494C14.82 14.2248 14.764 14.0286 14.6797 13.8607C14.5968 13.6921 13.9437 12.0304 13.6448 11.366Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

export default Whatsapp;
